import debounce from "debounce";

class MatchHeight {
	elements;
	heights = [];

	/**
	 * Instantiate class.
	 * 
	 * @param {HTMLElement} container
	 * @param {string} selector
	 */
	constructor( container, selector ) {
		this.elements = container.querySelectorAll( selector );
		
		this.runOnInit();
		this.registerResizeEvents();
	}

	/**
	 * Run as soon as fonts have loaded, or immediately if they already have.
	 */
	runOnInit() {
		if( 'loading' === document.fonts.status ) {
			document.fonts.ready.then( () => this.update() );
		} else {
			this.update();
		}
	}

	/**
	 * Watch for resize and update element heights.
	 */
	registerResizeEvents() {
		window.addEventListener( 'resize', debounce( () => this.update(), 100 ), { passive: true } );
	}

	/**
	 * Update element heights.
	 */
	update() {
		this.resetHeight();
		this.calculateHeight();
		this.setHeight();
	}

	/**
	 * Reset element heights before recalculating.
	 */
	resetHeight() {
		this.elements.forEach( element => {
			element.style.minHeight = null;
		} );

		this.heights = [];
	}

	/**
	 * Calculate the tallest element on which y position of the page (latitude).
	 */
	calculateHeight() {
		this.elements.forEach( element => {
			const size = element.getBoundingClientRect();
			const latitude = size.y;
			const height = size.height;

			if( typeof this.heights[latitude] === 'undefined' ) {
				this.heights[latitude] = {
					elements: [],
					maxHeight: 0
				};
			}

			this.heights[latitude].elements.push( element );

			if( height > this.heights[latitude].maxHeight ) {
				this.heights[latitude].maxHeight = height;
			}
		} );
	}

	/**
	 * Set height of each element on a row to that of the tallest element.
	 */
	setHeight() {
		for( const latitude in this.heights ) {
			this.heights[latitude].elements.forEach( element => {
				element.style.minHeight = this.heights[latitude].maxHeight + 'px';
			} );
		}
	}
}

document.querySelectorAll( '.e-con[data-whippet-match-height]' ).forEach( container => {
	new MatchHeight( container, container.dataset.whippetMatchHeight );
} );
